// Announcement bar dismiss on click (no persistence)
(function () {
  function initAnnouncementDismiss(root) {
    const scope = root || document;
    const closeButtons = scope.querySelectorAll('.announcement-bar__close');
    if (!closeButtons.length) return;

    closeButtons.forEach((btn) => {
      const bar = btn.closest('.utility-bar');
      btn.addEventListener('click', () => {
        if (bar) bar.style.display = 'none';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAnnouncementDismiss());
})();


// Announcement bar height -> CSS var on body
(function () {
  let resizeRaf;

  function getAnnouncementBar(root) {
    const scope = root || document;
    return (
      scope.querySelector('.announcement-bar-section .utility-bar') ||
      scope.querySelector('.utility-bar')
    );
  }

  function setAnnouncementHeight(root) {
    const bar = getAnnouncementBar(root);
    const height = bar ? bar.offsetHeight : 0;
    document.body.style.setProperty('--announcement-height', `${height}px`);
  }

  function onResize() {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(() => setAnnouncementHeight());
  }

  document.addEventListener('DOMContentLoaded', () => {
    setAnnouncementHeight();
    window.addEventListener('resize', onResize);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.announcement-bar__close');
    if (btn) {
      setTimeout(() => setAnnouncementHeight(), 0);
    }
  });
})();

// Footer Accordation for Mobile Device.
{
  const MOBILE_MAX = 767;

  const setup = () => {
    const blocks = document.querySelectorAll('.footer-block--menu');
    blocks.forEach((block) => {
      const heading = block.querySelector('.footer-accordion__heading');
      if (!heading) return;

      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');

      const toggle = () => {
        if (window.innerWidth > MOBILE_MAX) return; // only mobile
        const isOpen = block.classList.contains('open');

        if (!isOpen) {
          blocks.forEach((b) => {
            if (b !== block) {
              b.classList.remove('open');
              const h = b.querySelector('.footer-accordion__heading');
              if (h) h.setAttribute('aria-expanded', 'false');
            }
          });
        }

        block.classList.toggle('open');
        heading.setAttribute('aria-expanded', block.classList.contains('open') ? 'true' : 'false');
      };

      if (!heading.dataset.accordionBound) {
        heading.addEventListener('click', toggle);
        heading.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
        heading.dataset.accordionBound = 'true';
      }
    });

    if (window.innerWidth <= MOBILE_MAX) {
      document.querySelectorAll('.footer-block--menu').forEach((b) => b.classList.remove('open'));
    } else {
      document.querySelectorAll('.footer-block--menu').forEach((b) => b.classList.add('open'));
    }
  };

  setup();

  window.addEventListener('resize', () => {
    if (window.__footerAccordionRaf) cancelAnimationFrame(window.__footerAccordionRaf);
    window.__footerAccordionRaf = requestAnimationFrame(() => {
      const isDesktop = window.innerWidth > MOBILE_MAX;
      document.querySelectorAll('.footer-block--menu').forEach((b) => {
        if (isDesktop) {
          b.classList.add('open');
        } else {
          b.classList.remove('open');
        }
      });
    });
  });
}

// Product Tabs JS Logic
{
 // Click handling via delegation
document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.tabs__tab');
  if (!btn) return;

  const section = btn.closest('.product-tab-listing');
  if (!section) return;

  const targetId = 'tab-' + btn.id;
  const targetSliderId = 'tab-slider-btn-' + btn.id; // <-- slider-buttons id for this tab

  // Update tab buttons active state
  section.querySelectorAll('.tabs__tab').forEach((t) => {
    t.classList.toggle('is-active', t === btn);
  });

  // Show/hide content panels
  section.querySelectorAll('.tabs__content').forEach((panel) => {
    const isTarget = panel.id === targetId;
    panel.classList.toggle('hidden', !isTarget);
  });

  // Show/hide slider-buttons (only the matching slider-buttons should be visible)
  section.querySelectorAll('.slider-buttons').forEach((sb) => {
    const isTargetSlider = sb.id === targetSliderId;
    sb.classList.toggle('hidden', !isTargetSlider);
  });
});

function initProductTabs(root) {
  const scope = root || document;
  scope.querySelectorAll('.product-tab-listing').forEach((sec) => {
    const firstBtn = sec.querySelector('.tabs__tab');
    const firstPanelId = firstBtn ? 'tab-' + firstBtn.id : null;
    const firstSliderId = firstBtn ? 'tab-slider-btn-' + firstBtn.id : null;

    // Update buttons active state
    sec.querySelectorAll('.tabs__tab').forEach((t) => {
      t.classList.toggle('is-active', firstBtn && t === firstBtn);
    });

    // Show only the first panel
    sec.querySelectorAll('.tabs__content').forEach((p) => {
      const isFirst = firstPanelId && p.id === firstPanelId;
      p.classList.toggle('hidden', !isFirst);
    });

    // Show only the first slider-buttons
    sec.querySelectorAll('.slider-buttons').forEach((sb) => {
      const isFirstSlider = firstSliderId && sb.id === firstSliderId;
      sb.classList.toggle('hidden', !isFirstSlider);
    });
  });
}

// Initialize on first load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductTabs());
} else {
  initProductTabs();
}

// Re-initialize when section re-renders in Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target || document;
  initProductTabs(container);
});

}

// SEO SECTION ===========
{
  const faqItems = document.querySelectorAll(".seo-text-sec .faq-wrapper .faq-inner");
  if (faqItems.length) {
    faqItems.forEach((faq) => {
      const heading = faq.querySelector(".heading");
      if (!heading) return;

      heading.addEventListener("click", () => {
        const isActive = faq.classList.contains("active-faq");

        faqItems.forEach((item) => item.classList.remove("active-faq"));

        if (!isActive) faq.classList.add("active-faq");
      });
    });
  }
}

/* Per row grid display */

(function () {
  const mobileViewport = window.matchMedia("(max-width: 767px)");

  function getStorageKey() {
    return mobileViewport.matches
      ? "productsPerRowMobile"
      : "productsPerRowDesktop";
  }

  function activatePerRowButton(perRowValue) {
    document.querySelectorAll(".per-row__button").forEach((button) => {
      button.classList.toggle("active", button.dataset.perRow === perRowValue);
    });
  }

  function applyPerRowValue(perRowValue) {
    document.querySelectorAll("[data-productis-in-row]").forEach((el) => {
      el.setAttribute("data-productis-in-row", perRowValue);
    });

    activatePerRowButton(perRowValue);
  }

  function applyThemeDefault() {
    const grid = document.querySelector("[data-productis-in-row]");
    if (!grid) return;

    grid.setAttribute("data-productis-in-row", "");

    const columns = mobileViewport.matches
      ? grid.dataset.defaultColumnsMobile
      : grid.dataset.defaultColumnsDesktop;
    const perRowValue = mobileViewport.matches
      ? { 1: "one", 2: "two", 4: "four" }[columns]
      : { 3: "one", 4: "two", 6: "four" }[columns];

    activatePerRowButton(perRowValue);
  }

  function savePerRowValue(perRowValue) {
    try {
      localStorage.setItem(getStorageKey(), perRowValue);
    } catch (e) {
      console.warn("Could not save productsPerRow to localStorage", e);
    }
  }

  function readPerRowValue() {
    try {
      if (window.Shopify && window.Shopify.designMode) return null;
      return localStorage.getItem(getStorageKey());
    } catch (e) {
      return null;
    }
  }

  function initButtons() {
    const buttons = document.querySelectorAll(".per-row__button");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const perRowValue = button.dataset.perRow;
        applyPerRowValue(perRowValue);
        savePerRowValue(perRowValue);
      });
    });
  }

  function applyCurrentPerRowValue() {
    const saved = readPerRowValue();
    const matchesButton = saved && document.querySelector(
      `.per-row__button[data-per-row="${saved}"]`
    );

    if (matchesButton) {
      applyPerRowValue(saved);
    } else {
      applyThemeDefault();
    }
  }

  function init() {
    initButtons();
    applyCurrentPerRowValue();
  }

  mobileViewport.addEventListener("change", applyCurrentPerRowValue);

  document.addEventListener("shopify:section:load", function () {
    init();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


// Product Info Accordion =========
{
document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelector(".product-container .accordion-list");
  if (!accordion) return;
  const titles = accordion.querySelectorAll(".product-container .accordion-title");
  const contents = accordion.querySelectorAll(".product-container .accordion-content");

  // Hide all contents initially
  contents.forEach((content) => (content.style.display = "none"));

  // Show the first one by default
  if (titles.length > 0 && contents.length > 0) {
    titles[0].classList.add("active");
    contents[0].style.display = "block";
  }

  // Add click events to each title
  titles.forEach((title, index) => {
    title.addEventListener("click", function () {
      // Remove active class and hide all contents
      titles.forEach((t) => t.classList.remove("active"));
      contents.forEach((c) => (c.style.display = "none"));

      // Add active to the clicked title and show its content
      this.classList.add("active");
      if (contents[index]) {
        contents[index].style.display = "block";
      }
    });
  });
});
}

// shopthelook add to cart
function initLookbookSelectThenAdd() {
  // Remove old listeners by cloning relevant elements
  document.querySelectorAll('.lookbook-card__product').forEach(card => {
    card.querySelectorAll('.variant-item').forEach(btn => {
      const clone = btn.cloneNode(true);
      btn.replaceWith(clone);
    });

    const addBtn = card.querySelector('.product-form__submit');
    if (addBtn) {
      const cloneAdd = addBtn.cloneNode(true);
      addBtn.replaceWith(cloneAdd);
    }
  });

  // Initialize logic for each product card
  document.querySelectorAll('.lookbook-card__product').forEach(card => {
    const variantButtons = Array.from(card.querySelectorAll('.variant-item'));
    const addToCartBtn = card.querySelector('.product-form__submit');
    let selectedVariantId = null;

    if (!addToCartBtn) return;

    //  Disable add to cart initially
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');

    //  When user selects a variant
    variantButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

        // Remove active state from all buttons
        variantButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Store selected variant ID
        selectedVariantId = btn.dataset.variantId || null;

        //  Enable add to cart button
        if (selectedVariantId) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('disabled');
        }
      });
    });

    //  Add to cart click event
    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!selectedVariantId) return; // safety check

      const spinnerWrapper = addToCartBtn.querySelector('.loading__spinner');
      const label = addToCartBtn.querySelector('span');
      const cartDrawer = document.querySelector('cart-drawer');
      const cart = cartDrawer || document.querySelector('cart-notification');

      // Start loading
      addToCartBtn.classList.add('loading');
      addToCartBtn.disabled = true;
      if (label) label.style.opacity = '0';
      if (spinnerWrapper) spinnerWrapper.classList.remove('hidden');

      try {
        const formData = new FormData();
        formData.append('id', selectedVariantId);
        formData.append('quantity', 1);

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(s => s.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const data = await response.json();

        if (data.status) throw new Error('Add to cart failed');

        // Update cart drawer
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        // Success feedback
        addToCartBtn.classList.add('added-to-cart');
        setTimeout(() => addToCartBtn.classList.remove('added-to-cart'), 800);

      } catch (error) {
        console.error('Add to cart error:', error);
      } finally {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.disabled = false;
        if (label) label.style.opacity = '1';
        if (spinnerWrapper) spinnerWrapper.classList.add('hidden');
      }
    });
  });
}

// Reinit on page and Shopify section reload
document.addEventListener('DOMContentLoaded', initLookbookSelectThenAdd);
['shopify:section:load', 'shopify:section:select', 'shopify:block:select']
  .forEach(evt => document.addEventListener(evt, initLookbookSelectThenAdd));
  


// shopthelook swiper 
(function () {
  const SELECTOR = '.size-list.shopthelook, .size-list.shopthelook-1, .size-list.shopthelook-2';

  function makeKey(pid, sid) { return `sizeSwiper-${pid}-${sid}`; }

  function isVisible(el) {
    try {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    } catch (e) { return true; }
  }

  function initSizeListContainer(sizeListEl) {
    if (!sizeListEl) return;

    const swiperEl = sizeListEl.querySelector('.swiper.desktop-swiper');
    if (!swiperEl) return;

    const pid = swiperEl.dataset.swiperProduct;
    const sid = swiperEl.dataset.swiperSection;
    if (!pid || !sid) return;

    const key = makeKey(pid, sid);

    if (!swiperEl.classList.contains(key)) swiperEl.classList.add(key);

    const prevBtn = sizeListEl.querySelector('.swiper-button-prev') ||
      sizeListEl.querySelector(`[class*="prev-${pid}-${sid}"]`) ||
      sizeListEl.querySelector(`[class*="prev-${pid}"]`);
    const nextBtn = sizeListEl.querySelector('.swiper-button-next') ||
      sizeListEl.querySelector(`[class*="next-${pid}-${sid}"]`) ||
      sizeListEl.querySelector(`[class*="next-${pid}"]`);

    if (swiperEl.swiper) {
      try {
        if (prevBtn || nextBtn) {
          swiperEl.swiper.params.navigation = swiperEl.swiper.params.navigation || {};
          if (prevBtn) swiperEl.swiper.params.navigation.prevEl = prevBtn;
          if (nextBtn) swiperEl.swiper.params.navigation.nextEl = nextBtn;

          if (swiperEl.swiper.navigation && typeof swiperEl.swiper.navigation.init === 'function') {
            swiperEl.swiper.navigation.init();
            swiperEl.swiper.navigation.update();
          }
        }
        if (typeof swiperEl.swiper.update === 'function') swiperEl.swiper.update();
      } catch (e) {
        console.warn('lookshop:init - update existing swiper failed', e);
      }
      return;
    }

    if (swiperEl.classList.contains('swiper-initialized') && !swiperEl.swiper) {
      swiperEl.classList.remove('swiper-initialized');
    }

    const create = () => {
      try {
        const cfg = {
          slidesPerView: 'auto',
          spaceBetween: 14,
          slidesPerGroup: 1,
          freeMode: true,
          watchOverflow: true,
        };

        if (prevBtn || nextBtn) {
          cfg.navigation = {
            prevEl: prevBtn || undefined,
            nextEl: nextBtn || undefined
          };
        } else {
          cfg.navigation = {
            prevEl: `.prev-${pid}-${sid}`,
            nextEl: `.next-${pid}-${sid}`
          };
        }

        const instance = new Swiper(`.${key}`, cfg);

        setTimeout(() => {
          if (instance && typeof instance.update === 'function') instance.update();
        }, 0);

        swiperEl.lookshopSwiper = instance;
      } catch (err) {
        console.error('lookshop:create swiper failed for', key, err);
      }
    };

    if (isVisible(sizeListEl)) {
      create();
    } else {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            create();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.01 });
      io.observe(sizeListEl);
    }
  }

  function initAllLookshop(root) {
    const ctx = root || document;
    const nodes = ctx.querySelectorAll(SELECTOR);
    nodes.forEach(n => initSizeListContainer(n));
  }

  document.addEventListener('DOMContentLoaded', () => initAllLookshop(document));
  ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:section:unload'].forEach(evt => {
    document.addEventListener(evt, (e) => {
      try {
        if (evt === 'shopify:section:unload' && e && e.target instanceof HTMLElement) {

          e.target.querySelectorAll(SELECTOR).forEach(container => {
            const sw = container.querySelector('.swiper.desktop-swiper');
            if (!sw) return;
            try {
              if (sw.swiper && typeof sw.swiper.destroy === 'function') sw.swiper.destroy(true, true);
            } catch (err) {}
            const pid = sw.dataset.swiperProduct, sid = sw.dataset.swiperSection;
            if (pid && sid) sw.classList.remove(makeKey(pid, sid));
          });
          return;
        }
      } catch (err) {}
      initAllLookshop(document);
    });
  });

  window.lookshopDebug = function () {
    return Array.from(document.querySelectorAll(SELECTOR)).map(el => {
      const sw = el.querySelector('.swiper.desktop-swiper');
      return {
        container: el,
        pid: sw && sw.dataset ? sw.dataset.swiperProduct : null,
        sid: sw && sw.dataset ? sw.dataset.swiperSection : null,
        hasClass: sw ? sw.className : null,
        hasInstance: !!(sw && sw.swiper)
      };
    });
  };

  setTimeout(() => initAllLookshop(document), 200);
})();  

{
  document.querySelectorAll('.js-accordion-list').forEach(function(accordion) {
    accordion.querySelectorAll('.js-accordation-button').forEach(function(btn) {
      btn.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const panelId = this.getAttribute('aria-controls');
        const panel = document.getElementById(panelId);

        // toggle this panel
        this.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          if (expanded) {
            panel.hidden = true;
          } else {
            panel.hidden = false;
          }
        }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  });
}

{
  function getBroswerDetails() {
    //Checking the user's OS and Browser
    if ((navigator.userAgent).includes("Android")) {
        document.querySelector("html").classList.add("android");
    } else if ((navigator.userAgent).includes("Mac")) {
        document.querySelector("html").classList.add("mac");
    } else {
        document.querySelector("html").classList.add("windows");
    }

    //-- Browser --//
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    var isBlink = (isChrome || isOpera) && !!window.CSS;
    if (isFirefox) {
        document.querySelector("html").classList.add("isFirefox")
    } else if (isChrome) {
        document.querySelector("html").classList.add("isChrome")
    } else if (isSafari) {
        document.querySelector("html").classList.add("isSafari")
    } else if (isOpera) {
        document.querySelector("html").classList.add("isOpera")
    } else if (isIE) {
        document.querySelector("html").classList.add("isIE")
    } else if (isEdge) {
        document.querySelector("html").classList.add("isEdge")
    } else if (isEdgeChromium) {
        document.querySelector("html").classList.add("isEdgeChromium")
    } else {
        document.querySelector("html").classList.add("isBlink")
    }
  }
  getBroswerDetails();

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    // true for mobile device
    document.querySelector("html").classList.add("mobile");
  }
}

// Filter Drawer Body Class Toggle
{
  const details = document.querySelector('.mobile-facets__disclosure');
  if (details) {
    details.addEventListener('toggle', (event) => {
      if (details.open) {
        document.body.classList.add('filter-open');
      } else {
        document.body.classList.remove('filter-open');
        document.body.classList.remove('overflow-hidden-mobile');
      }
    });
  }
}

// FAQ PAGE =============
{
  if (!customElements.get('faq-toc')) {
    customElements.define('faq-toc', class FaqToc extends HTMLElement {
      constructor() {
        super();
        this.container = this.closest('.faq');
        if (!this.container) return;
        
        this.links = this.querySelectorAll('.faq__toc-item');
        this.categories = this.container.querySelectorAll('.faq__category');
        
        this.scrollOffset = 20; 
        if (this.links.length > 0) {
           this.init();
        }
      }

      init() {
        this.links.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href').replace('#', '');
            
            if (window.innerWidth <= 767) {
              this.updateActiveTab(targetId);
            } else {
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                const header = document.querySelector('.section-header');
                const headerHeight = header ? header.offsetHeight : 0;
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerHeight - this.scrollOffset;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }
          });
        });

        if (this.categories.length > 0) {
          const observerOptions = {
            root: null,
            rootMargin: '-150px 0px -70% 0px', 
            threshold: 0
          };

          this.observer = new IntersectionObserver((entries) => {
            // Only use observer on desktop
            if (window.innerWidth > 767) {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  const id = entry.target.getAttribute('id');
                  this.updateActiveLink(id);
                }
              });
            }
          }, observerOptions);

          this.categories.forEach(category => this.observer.observe(category));
        }
      }

      updateActiveTab(id) {
        this.links.forEach(link => {
          link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
        this.container.querySelectorAll('.faq__tab-content').forEach(tab => {
          tab.classList.toggle('is-active', tab.id === `tab-${id}`);
        });
      }

      updateActiveLink(id) {
        this.links.forEach(link => {
          const isActive = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', isActive);
        });
      }
    });
  }
}

// Register Form Validation
document.addEventListener("DOMContentLoaded", function () {
  const registerForm = document.getElementById('create_customer');
  if (!registerForm) return;

  function showError(input, message) {
    let fieldContainer = input.closest('.field') || input.closest('.field--checkbox');
    if (!fieldContainer) return;

    input.setAttribute('aria-invalid', 'true');
    input.style.borderColor = '#e32c2b';

    let errorSpan = fieldContainer.nextElementSibling;
    let isCustomError = errorSpan && errorSpan.classList.contains('custom-field-error');

    if (!isCustomError) {
      errorSpan = document.createElement('span');
      errorSpan.classList.add('custom-field-error');
      errorSpan.style.color = '#EA3E3E';
      errorSpan.style.fontSize = '1.4rem';
      errorSpan.style.display = 'block';
      errorSpan.style.marginTop = '0.6rem';
      errorSpan.style.textAlign = 'left';
      fieldContainer.insertAdjacentElement('afterend', errorSpan);
    }
    errorSpan.innerText = message;
    errorSpan.style.display = 'block';
  }

  function hideError(input) {
    input.removeAttribute('aria-invalid');
    input.style.borderColor = '';
    let fieldContainer = input.closest('.field') || input.closest('.field--checkbox');
    if (fieldContainer) {
      let errorSpan = fieldContainer.nextElementSibling;
      if (errorSpan && errorSpan.classList.contains('custom-field-error')) {
        errorSpan.style.display = 'none';
      }
    }
  }

  function validateInput(input) {
    const val = input.value.trim();
    if (!val) {
      showError(input, 'Este campo es obligatorio');
      return false;
    }

    if (input.type === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(val)) {
        showError(input, 'Por favor, introduce un correo electrónico válido');
        return false;
      }
    }

    if (input.type === 'password') {
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!passwordRegex.test(val)) {
        showError(input, 'La contraseña debe: Incluir un carácter en mayúscula (A-Z), incluir un número y tener al menos 8 carácteres.');
        return false;
      }
    }

    hideError(input);
    return true;
  }

  registerForm.addEventListener('submit', function (e) {
    let isFormValid = true;
    const requiredInputs = registerForm.querySelectorAll('input[type="text"], input[type="email"], input[type="password"]');

    requiredInputs.forEach(input => {
      if (!validateInput(input)) {
        isFormValid = false;
      }
    });

    const requiredCheckbox = registerForm.querySelector('input[type="checkbox"][required]');
    if (requiredCheckbox) {
      if (!requiredCheckbox.checked) {
        isFormValid = false;
        showError(requiredCheckbox, 'Este campo es obligatorio');
      } else {
        hideError(requiredCheckbox);
      }
    }

    if (!isFormValid) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });

  const inputs = registerForm.querySelectorAll('input[type="text"], input[type="email"], input[type="password"]');
  inputs.forEach(input => {
    input.addEventListener('input', function () {
      validateInput(this);
    });
    input.addEventListener('blur', function () {
      validateInput(this);
    });
  });

  const checkInputs = registerForm.querySelectorAll('input[type="checkbox"][required]');
  checkInputs.forEach(input => {
    input.addEventListener('change', function () {
      if (this.checked) {
        hideError(this);
      } else {
        showError(this, 'Este campo es obligatorio');
      }
    });
  });
});

// ul li Variant Dropdown Logic
(function () {
  function setSelectValue(select, value) {
    if (!select) return false;
    
    var targetIndex = -1;
    var options = select.options;
    
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var isMatch = (opt.value === value);
      opt.selected = isMatch;
      
      if (isMatch) {
        targetIndex = i;
        opt.setAttribute('selected', 'selected');
      } else {
        opt.removeAttribute('selected');
      }
    }

    if (targetIndex !== -1) {
      select.selectedIndex = targetIndex;
      return true;
    }
    return false;
  }

  function variantChange(element) {
    if (!element) return;
    var event;
    try {
      event = new Event('change', { bubbles: true, composed: true });
    } catch (e) {
      event = document.createEvent('Event');
      event.initEvent('change', true, true);
    }
    element.dispatchEvent(event);
  }

  function closeDropdown(dropdown) {
    if (dropdown && dropdown.hasAttribute('open')) {
      dropdown.removeAttribute('open');
      dropdown.open = false; 
    }
  }

  function initDropdowns() {
    document.querySelectorAll('.js-variant-dropdown').forEach(function (dropdown) {
      if (dropdown.dataset.initialized) return;
      dropdown.dataset.initialized = 'true';

      var selectElement = dropdown.closest('.js-select');
      var selectElement = selectElement && selectElement.querySelector('select');
      var label = dropdown.querySelector('[data-dropdown-value]');

      dropdown.querySelectorAll('.js-variant-dropdown__item').forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!selectElement) return;

          if (setSelectValue(selectElement, item.dataset.value)) {
            variantChange(selectElement);
          }

          if (label) {
            var itemSpan = item.querySelector('span');
            label.innerText = itemSpan ? itemSpan.innerText.trim() : item.innerText.trim();
          }

          dropdown.querySelectorAll('.js-variant-dropdown__item').forEach(function (i) {
            i.classList.toggle('is-selected', i === item);
          });

          closeDropdown(dropdown);
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.js-variant-dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) closeDropdown(d);
    });
  });

  var isSyncing = false;

  document.addEventListener('change', function (e) {
    if (isSyncing) return;

    var input = e.target;
    var variant_select = input && input.closest('variant-selects');
    if (!variant_select) return;

    var valueId;
    if (input.type === 'radio') {
      valueId = input.dataset.optionValueId;
    } else if (input.tagName === 'SELECT') {
      var selectedOpt = input.options[input.selectedIndex];
      valueId = selectedOpt && selectedOpt.dataset.optionValueId;
    }
    if (!valueId) return;

    isSyncing = true;
    
    setTimeout(function() {
      try {
        document.querySelectorAll('variant-selects').forEach(function (other_variant_select) {
          if (other_variant_select === variant_select) return;

          var matchingRadio = other_variant_select.querySelector('input[type="radio"][data-option-value-id="' + valueId + '"]');
          if (matchingRadio && !matchingRadio.checked) {
            matchingRadio.checked = true;
          }

          var matchingOption = other_variant_select.querySelector('option[data-option-value-id="' + valueId + '"]');
          if (matchingOption) {
            var select_element = matchingOption.closest('select');
            if (select_element) {
              setSelectValue(select_element, matchingOption.value);

              var js_select_element = select_element.closest('.js-select');
              var dropdownEl = js_select_element && js_select_element.querySelector('.js-variant-dropdown');
              if (dropdownEl) {
                var dropLabel = dropdownEl.querySelector('[data-dropdown-value]');
                var matchingItem = dropdownEl.querySelector('.js-variant-dropdown__item[data-option-value-id="' + valueId + '"]');
                if (matchingItem) {
                  if (dropLabel) {
                    var span = matchingItem.querySelector('span');
                    dropLabel.innerText = span ? span.innerText.trim() : matchingOption.value;
                  }
                  dropdownEl.querySelectorAll('.js-variant-dropdown__item').forEach(function (i) {
                    i.classList.toggle('is-selected', i === matchingItem);
                  });
                }
              }
            }
          }
        });
      } catch (err) {
        console.warn('Variant sync failed:', err);
      } finally {
        isSyncing = false;
      }
    }, 0);
  });

  initDropdowns();
  document.addEventListener('shopify:section:load', initDropdowns);
  document.addEventListener('DOMContentLoaded', initDropdowns);

  (function() {
    window.initLazyImages = function(root) {
      const context = root || document;
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const card = entry.target;
            const lazyImages = card.querySelectorAll('.lazy-deferred-image');
            lazyImages.forEach(img => {
              if (img.dataset.src) {
                img.src = img.dataset.src;
                if (img.dataset.srcset) img.srcset = img.dataset.srcset;
                img.classList.remove('lazy-deferred-image');
              }
            });
            obs.unobserve(card);
          }
        });
      }, { rootMargin: '0px 0px 400px 0px' });

      const cards = context.querySelectorAll('.card-wrapper');
      cards.forEach(card => observer.observe(card));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => window.initLazyImages());
    } else {
      window.initLazyImages();
    }
    
    document.addEventListener('shopify:section:load', (e) => window.initLazyImages(e.target));

    const gridObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList.contains('card-wrapper')) {
              window.initLazyImages(node.parentElement);
            } else if (node.querySelector('.card-wrapper')) {
              window.initLazyImages(node);
            }
          }
        });
      });
    });
    
    gridObserver.observe(document.body, { childList: true, subtree: true });
  })();
})();
